import React from 'react';
import PropTypes from 'prop-types';
import DRIcon from '../../icons/icon-demand-response.svg';
import InstallIcon from '../../icons/icon-configure-products.svg';


const IconComponentsMap = {
  dr: DRIcon,
  install: InstallIcon,
};

const AddOnIcon = ({ className, type }) => {
  const IconComponent = IconComponentsMap[type];

  if (!IconComponent) {
    return null;
  }

  return (<IconComponent className={className} />);
};

AddOnIcon.propTypes = {
  className: PropTypes.string,
  type: PropTypes.oneOf(Object.keys(IconComponentsMap)),
};

AddOnIcon.defaultProps = {
  className: null,
  type: null,
};

export default AddOnIcon;
